import { IRequestFetcherOptions, IParamsOption } from "src/common/razzle-platform-components/types"
import { fetchProduct, fetchProducts } from "src/common/razzle-platform-product/effects"
import { Store } from 'src/redux'

// we fixed this PRODUCT_PROPS_ID for use it to save our props in reudcer
export const PRODUCT_PROPS_ID = 'productProps'


// we use this function to get the product on the server side
export async function getInitialPropsOfProduct({ route }, store: Store,  options: Pick<IParamsOption, 'params'> = {}) {
    try {
        const { id } = route.params;
        const { dispatch, getState } = store

        // in product we need params for make forced request exmaple: parms: { _embed: [user, ...etc]}
		const queryOptions: Pick<IRequestFetcherOptions, 'params'> = {
			params: options.params,
		}

        // get the locale
		const locale: string = getState().translationModel.locale

		// set the Accept-Language to the headers of the request for get the translated data
		const headers = { "Accept-Language": locale }

		// get the product by execute the effect fetchProduct and pass it queryOptions
		const { product } = await fetchProduct(id, queryOptions, headers)

        // save the initialProps in the reducer
		dispatch.ssrModel.setInitialProps({ [PRODUCT_PROPS_ID]: { product, queryOptions } })

    } catch (error) {
        console.log('mmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm', error)
    }
}

// we fixed this PRODUCTS_PROPS_ID for use it to save our props in reudcer
export const PRODUCTS_PROPS_ID = 'productsProps'

// we use this function to get the products on the server side
export async function getInitialPropsOfProducts({ route }, store: Store, options: IParamsOption={params: null, useUrlParams: true, usePagination: true }) {
	try {
        const { dispatch, getState } = store

        const queryOptions: IRequestFetcherOptions = {
            // prams given from url
            searchParams: route.query,
            // forced params by user not it's shown in url
            params: options.params,
            // to allow use pagination
            usePagination: options.usePagination,
            // to allow use search parms from url
            useUrlParams: options.useUrlParams
        }

        // get the locale
		const locale: string = getState().translationModel.locale

		// set the Accept-Language to the headers of the request for get the translated data
		const headers = { "Accept-Language": locale }

        // get the products by execute the effect fetchProducts and pass it queryOptions
        const { products, pagination } = await fetchProducts(queryOptions, headers)

        // save the initialProps in the reducer
        dispatch.ssrModel.setInitialProps({ [PRODUCTS_PROPS_ID]: { products, pagination, queryOptions } })

	} catch (error) {
        console.log('errrrorrrr', error)
	}
}
